/**
 * Effective role resolution for auth + admin QA view-as mode.
 */

import { getClientPricingRouteRedirect } from './pricingLaneDisplay';

export const ROLE_USER = 'USER';
export const ROLE_OWNER = 'OWNER';
export const ROLE_ADMIN = 'ADMIN';

export const ROUTE_OWNER_DASHBOARD = '/owner/dashboard';
export const ROUTE_CLIENT_DASHBOARD = '/dashboard';
export const ROUTE_GUEST_BOOKINGS = '/bookings';
export const ROUTE_ADMIN = '/admin';

export function resolveEffectiveRole({ user, isAdmin, viewAsRole }) {
  if (isAdmin && viewAsRole) {
    return viewAsRole;
  }
  return String(user?.role || '').toUpperCase();
}

export function canAccessOwnerRoutes({ user, isAdmin, viewAsRole }) {
  const effectiveRole = resolveEffectiveRole({ user, isAdmin, viewAsRole });
  if (isAdmin && viewAsRole === ROLE_USER) {
    return false;
  }
  if (isAdmin && viewAsRole === ROLE_OWNER) {
    return true;
  }
  return effectiveRole === ROLE_OWNER || effectiveRole === ROLE_ADMIN;
}

export function showsOwnerNavigation({ user, isAdmin, viewAsRole }) {
  return canAccessOwnerRoutes({ user, isAdmin, viewAsRole });
}

export function showsAdminNavigation({ user, isAdmin, viewAsRole }) {
  return isAdmin && !viewAsRole;
}

export function isGuestContext({ user, isAdmin, viewAsRole }) {
  const effectiveRole = resolveEffectiveRole({ user, isAdmin, viewAsRole });
  if (isAdmin && viewAsRole) {
    return viewAsRole === ROLE_USER;
  }
  return effectiveRole === ROLE_USER;
}

export function getDefaultRouteForRole(role) {
  const normalized = String(role || '').toUpperCase();
  if (normalized === ROLE_ADMIN) {
    return ROUTE_ADMIN;
  }
  if (normalized === ROLE_OWNER) {
    return ROUTE_OWNER_DASHBOARD;
  }
  return ROUTE_CLIENT_DASHBOARD;
}

export function getRouteGuardRedirect(pathname, { user, isAdmin, viewAsRole }) {
  if (!user) {
    return null;
  }

  const path = pathname || '';

  if (isAdmin && viewAsRole === ROLE_USER) {
    if (path.startsWith('/owner') || path.startsWith('/admin')) {
      return ROUTE_CLIENT_DASHBOARD;
    }
  }

  if (isAdmin && viewAsRole === ROLE_OWNER) {
    if (path.startsWith('/admin')) {
      return ROUTE_OWNER_DASHBOARD;
    }
  }

  const role = String(user.role || '').toUpperCase();
  if (role === ROLE_USER && path.startsWith('/owner')) {
    return ROUTE_CLIENT_DASHBOARD;
  }

  if (role === ROLE_OWNER && path.startsWith('/admin')) {
    return ROUTE_OWNER_DASHBOARD;
  }

  const pricingRedirect = getClientPricingRouteRedirect(path, { user, isAdmin, viewAsRole });
  if (pricingRedirect) {
    return pricingRedirect;
  }

  return null;
}
